type HistoryItem = { name: string; code: string }

/**
 * Reads the search history for the given localStorage key.
 * Returns up to 3 items, or an empty array if nothing is stored.
 */
export function getSearchHistory(key: string): HistoryItem[] {
  try {
    const stored = localStorage.getItem(key)
    return stored ? JSON.parse(stored) : []
  } catch {
    return []
  }
}

/**
 * Prepends an item to the search history for the given localStorage key.
 * Deduplicates by code and keeps only the 3 most recent entries.
 */
export function addToSearchHistory(key: string, item: HistoryItem): void {
  const history = getSearchHistory(key).filter((h) => h.code !== item.code)
  history.unshift(item)
  localStorage.setItem(key, JSON.stringify(history.slice(0, 3)))
}
